import styled, { css } from 'styled-components';
import theme from 'styles/theme';

export const ColorOptionStyled = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const SidebarNavStyled = styled.div`
  border-right: 1px solid ${theme.colors.gray300};
  padding-right: 0;

  .nav {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .nav > li {
    text-align: start;
  }

  .nav > li > a {
    color: ${theme.colors.fontDark};
    padding: 10px 14px;
    border-radius: 4px;
  }

  .nav > li.active > a,
  .nav > li.active > a:hover,
  .nav > li.active > a:focus {
    background-color: ${theme.colors.bgHover};
    color: ${theme.colors.primary};
    font-weight: 600;
  }

  .nav > li.disabled > a,
  .nav > li.disabled > a:hover,
  .nav > li.disabled > a:focus {
    background-color: transparent;
    color: ${theme.colors.gray500};
    cursor: not-allowed;
  }

  .nav > li.disabled > a .tooltip-container {
    pointer-events: auto;
  }
`;

export const TabContentStyled = styled.div`
  padding-left: 20px;
  display: flex;
  flex-direction: column;

  .policy-period {
    .policy-period-label {
      margin-left: 16px;
    }
  }
`;

export const DateRangeLabelStyled = styled.label<{ $isRequired: boolean }>`
  display: block;
  font-weight: 700;
  margin-bottom: 6px;
  padding-left: 15px;
  padding-top: 7px;

  ${({ $isRequired }) =>
    $isRequired &&
    css`
      &::after {
        content: '*';
        color: #a94442;
        margin-left: 4px;
        position: absolute;
      }
    `}
`;

export const DateRangeFieldsStyled = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 12px;
`;

export const DateRangeInputStyled = styled.div`
  flex: 1;
`;

export const DateRangeArrowStyled = styled.span`
  color: ${theme.colors.gray500};
  font-size: 18px;
  line-height: 34px;
`;

export const IconContainer = styled.span`
  display: inline-block;
  width: 24px;
  height: 24px;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
